import Globals from 'system/Globals'

export function openLink(url) {
    if (Globals.instance().electron) {
        window.api.send("toApp", { event: "external-link", link: url })
    } else if (Globals.instance().ios) {
        window.webkit.messageHandlers.notification.postMessage({ Object: 'external-link', link: url })
    } else {
        window.open(url, "_blank")
    }
}
